import React from 'react';

import './styles.scss';

const Separator = () => <hr className={'separator'} />;

export default Separator;
